import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { DropdownListSide as l } from "../../../../../Dropdown/components/DropdownList/index.js";
import { HeaderContainer as C, LeftContent as h, Timestamp as L, EditedText as A, CommentOptionsOnContent as u } from "./style.js";
import { NewCommentFlag as w } from "../../../CommentFlags/index.js";
import { Author as x } from "../../../../style.js";
import { CommentAvatarOnView as S } from "../../../CommentView/style.js";
import { AvatarSize as T } from "../../../../../../components/Avatar/style.js";
import { useTranslation as H } from "../../../../../../hooks/useTranslation/index.js";
import { useAbstractedLink as O } from "../../../../../../contexts/RouterAbstraction/context.js";
const F = ({
  author: t,
  goToProfile: n,
  timestamp: r,
  isEdited: i,
  isNewComment: m,
  moreOptions: d,
  isAuthorVerified: s,
  authorImage: p,
  profileURL: f
}) => {
  const c = O(), { t: a } = H("common");
  return /* @__PURE__ */ e(C, { children: [
    /* @__PURE__ */ e(h, { children: [
      /* @__PURE__ */ o(
        S,
        {
          author: t,
          authorImage: p,
          goToProfile: n,
          size: T.SMALL
        }
      ),
      /* @__PURE__ */ o(c, { href: f, children: /* @__PURE__ */ o(x, { isVerified: s, children: t || "" }) }),
      r && /* @__PURE__ */ o(L, { timestamp: r }),
      i && /* @__PURE__ */ e(A, { children: [
        " · ",
        a("helpful-comment-edited")
      ] }),
      m && /* @__PURE__ */ o(w, {})
    ] }),
    /* @__PURE__ */ o(
      u,
      {
        moreOptions: d,
        dropdownListSide: l.RIGHT
      }
    )
  ] });
};
export {
  F as CommentContentHeader
};
